// extracted by mini-css-extract-plugin
export var wrapper = "r_b";
export var fixed = "r_R";
export var burger = "r_bK";
export var active = "r_bL";